import { LONGLAT } from "../../actions/portal/";

export default function(state = [120.8027369, -2.7444906], action){
  switch (action.type) {
    case LONGLAT:
    return action.payload;
    default:
  }

  return state;
}
